export default __webpack_public_path__ + "static/media/apple.9ffef4ac.png";